'use client';

import { ReactNode, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

import { useNotifications } from '@personly/libs-providers';

interface Props {
  children?: ReactNode;
}

const ErrorCode = ({ children }: Props) => {
  const searchParams = useSearchParams();
  const { createNotification } = useNotifications();

  useEffect(() => {
    if (!searchParams.has('code')) return;
    createNotification('ERROR', searchParams.get('code') ?? '');
  }, [createNotification, searchParams]);

  return children;
};

export default ErrorCode;
